// Gift card PDP: keeps the recipient preview card in sync with the chosen amount,
// recipient name, message and send date.
(function () {
  function init(card) {
    var form = card.closest('recipient-form');
    if (!form) return;
    var sectionId = form.dataset.sectionId;
    var amountEl = card.querySelector('[data-gc-amount]');
    var nameEl = card.querySelector('[data-gc-name]');
    var msgEl = card.querySelector('[data-gc-message]');
    var whenEl = card.querySelector('[data-gc-when]');
    var nameInput = document.getElementById('Recipient-name-' + sectionId);
    var msgInput = document.getElementById('Recipient-message-' + sectionId);
    var dateInput = document.getElementById('Recipient-send-on-' + sectionId);
    var lang = document.documentElement.lang || 'da';

    function syncAmount() {
      var checked = document.querySelector('.gc-amounts input[type="radio"]:checked');
      var label = checked && document.querySelector('label[for="' + checked.id + '"]');
      if (label) amountEl.textContent = label.textContent.trim();
    }

    function syncText() {
      var name = nameInput && nameInput.value.trim();
      nameEl.textContent = name || card.dataset.gcToBlank;
      var msg = msgInput && msgInput.value.trim();
      msgEl.textContent = msg;
      msgEl.hidden = !msg;
      var d = dateInput && dateInput.value ? new Date(dateInput.value + 'T12:00:00') : null;
      if (d && !isNaN(d)) {
        var formatted = d.toLocaleDateString(lang, { day: 'numeric', month: 'long' });
        whenEl.textContent = card.dataset.gcWhenDate.replace('[date]', formatted);
      } else {
        whenEl.textContent = card.dataset.gcWhenNow;
      }
    }

    [nameInput, msgInput, dateInput].forEach(function (el) {
      if (el) {
        el.addEventListener('input', syncText);
        el.addEventListener('change', syncText);
      }
    });
    // Variant radios can be re-rendered on change, so listen at document level.
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('.gc-amounts')) syncAmount();
    });
    syncAmount();
    syncText();
  }

  function boot() {
    document.querySelectorAll('.gc-card').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
